import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Śledzi zmiany strony w SPA dla Plausible Analytics
export default function usePlausible() {
  const location = useLocation();

  useEffect(() => {
    // Plausible automatycznie śledzi page views przez script.js
    // Ten hook wysyła dodatkowe zdarzenie przy każdej zmianie URL w SPA
    if (typeof window.plausible === 'function') {
      window.plausible('pageview');
    }
  }, [location.pathname]);
}

// Helper do śledzenia custom eventów
// Użycie: trackEvent('Kliknięcie ogłoszenia', { props: { typ: 'sprzedaz' } })
export function trackEvent(eventName, options = {}) {
  if (typeof window.plausible === 'function') {
    window.plausible(eventName, options);
  }
}
